"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiAttach16 = {
    paths: [
        {
            path: 'M3,13.971831 C3.55228475,13.971831 4,13.5178099 4,12.9577465 L4,6.01408451 C4,5.4540211 4.44771525,5 5,5 C5.55228475,5 6,5.4540211 6,6.01408451 L6,12.9577465 C6,14.6379367 4.65685425,16 3,16 C1.37547287,16 0.0525320466,14.690569 0.00152629916,13.0557227 C0.000513205448,13.0372772 0,13.0186985 0,13 L0,5 C0,2.23857625 2.23857625,0 5,0 C7.76142375,0 10,2.23857625 10,5 L10,15 C10,15.5522847 9.55228475,16 9,16 C8.44771525,16 8,15.5522847 8,15 L8,5 C8,3.34314575 6.65685425,2 5,2 C3.34314575,2 2,3.34314575 2,5 L2,12.9577467 C2,13.5178099 2.44771525,13.971831 3,13.971831 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Attach',
    width: 10,
    height: 16,
};
var muiAttach24 = {
    paths: [
        {
            path: 'M2,20.9577465 C2,21.5178099 2.44771525,21.971831 3,21.971831 C3.55228475,21.971831 4,21.5178099 4,20.9577465 L4,7.01408451 C4,6.4540211 4.44771525,6 5,6 C5.55228475,6 6,6.4540211 6,7.01408451 L6,20.9577465 C6,22.6379367 4.65685425,24 3,24 C1.37547287,24 0.0525320466,22.690569 0.00152629916,21.0557227 C0.000513205447,21.0372772 0,21.0186985 0,21 L0,5 C0,2.23857625 2.23857625,0 5,0 C7.76142375,0 10,2.23857625 10,5 L10,19 C10,19.5522847 9.55228475,20 9,20 C8.44771525,20 8,19.5522847 8,19 L8,5 C8,3.34314575 6.65685425,2 5,2 C3.34314575,2 2,3.34314575 2,5 L2,20.9577467 L2,20.9577465 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Attach',
    width: 10,
    height: 24,
};
var muiAttach = {
    base: muiAttach16,
    smIcon: muiAttach16,
    lgIcon: muiAttach24,
};
exports.muiAttach = muiAttach;
//# sourceMappingURL=attach.js.map